import { render, staticRenderFns } from "./DeliveryReportComponent.vue?vue&type=template&id=30147a56&"
import script from "./DeliveryReportComponent.vue?vue&type=script&lang=js&"
export * from "./DeliveryReportComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports